import { Link, Text } from '@chakra-ui/react'
import type { FC } from 'react'

import { useColorModeValue } from '@app/components/ui/color-mode'
import cardFontSize from '@app/shared/cards/cardFontSize'
import type { CardSize } from '@app/types'

type Props = {
  url: string
  text?: string | null
  size?: CardSize
}

const CardDetailsLink: FC<Props> = ({ url, text = null, size = 'normal' }) => {
  const color = useColorModeValue('gray.700', 'gray.400')
  const fontSize = cardFontSize('sm', size)

  const title = text || 'External resource'

  return (
    <Link color={color} href={url} rel="onoopener noreferrer" target="_blank">
      <Text as="span" color="fg.subtle" fontSize={fontSize} _hover={{ textDecoration: 'underline' }}>
        {title}
      </Text>{' '}
      <Text as="span" color="fg.subtle" fontSize={fontSize}>
        ↗
      </Text>
    </Link>
  )
}

export default CardDetailsLink
